import { useSuspenseQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';

import { Heading, Stack, Text } from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';

import {
  FactVerificationInputResultsListItem,
  inputResultsFragment,
} from './FactVerificationInputResultsListItem';

const query = graphql(
  `
    query getFactVerificationModelPromptTemplate($id: uuid!) {
      evalFactVerificationWorkflowModelPromptTemplatesByPk(id: $id) {
        __typename
        id
        inputs {
          ...inputResults
        }
        model_prompt_template {
          __typename
          id
          model_args {
            __typename
            id
            args
            modelType
          }
          template {
            __typename
            id
            name
          }
        }
        output_template {
          __typename
          id
          name
        }
      }
    }
  `,
  [inputResultsFragment],
);

export interface FactVerificationModelPromptTemplatePageProps {}

export const FactVerificationModelPromptTemplatePage: React.FC<
  FactVerificationModelPromptTemplatePageProps
> = () => {
  const { modelPromptTemplateId } = useParams() as {
    workflowId: string;
    modelPromptTemplateId: string;
  };

  const {
    data: {
      evalFactVerificationWorkflowModelPromptTemplatesByPk:
        workflowModelPromptTemplate,
    },
  } = useSuspenseQuery(query, {
    variables: {
      id: modelPromptTemplateId,
    },
  });

  const modelArgs =
    workflowModelPromptTemplate?.model_prompt_template?.model_args;
  const promptTemplate =
    workflowModelPromptTemplate?.model_prompt_template?.template;
  const outputTemplate = workflowModelPromptTemplate?.output_template;

  const inputs = workflowModelPromptTemplate?.inputs ?? [];

  return (
    <>
      <div className="my-2 py-2">
        <Heading>Workflow Results</Heading>
      </div>
      <Stack gap={8} className="pb-8" direction="horizontal">
        <Stack gap={2}>
          <Heading size="xl" weight="semibold">
            Model Info
          </Heading>
          <Text>{modelArgs?.modelType ?? ''}</Text>
          <code className="rounded-sm bg-bg-quaternary p-0.5 text-xs text-text-primary">
            {JSON.stringify(modelArgs?.args)}
          </code>
        </Stack>

        <Stack gap={2}>
          <Heading size="xl" weight="semibold">
            Prompt Template
          </Heading>
          <Text>{promptTemplate?.name ?? ''}</Text>
        </Stack>

        {outputTemplate && (
          <Stack gap={2}>
            <Heading size="xl" weight="semibold">
              Output Template
            </Heading>
            <Text>{outputTemplate?.name ?? ''}</Text>
          </Stack>
        )}
      </Stack>

      <Heading size="xl" weight="semibold">
        {' '}
        Results{' '}
      </Heading>
      <ul className="mt-4 divide-y divide-border-primary">
        {inputs.map((i) => (
          <FactVerificationInputResultsListItem key={i.id} id={i.id} />
        ))}
      </ul>
    </>
  );
};
